import React from 'react';
import { Card, CardContent } from './ui/card';
import { ClipboardCheck, Settings, BarChart3 } from 'lucide-react';
import { howItWorksData } from '../data/mock';

const iconMap = {
  1: ClipboardCheck,
  2: Settings,
  3: BarChart3
};

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground">
            Our streamlined three-step process ensures smooth onboarding and ongoing compliance support.
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {howItWorksData.map((step, index) => {
              const Icon = iconMap[step.step];
              return (
                <div key={step.step} className="relative">
                  <Card className="h-full border-2 hover:border-secondary transition-all duration-300 hover:shadow-xl">
                    <CardContent className="p-8">
                      {/* Step Number Badge */}
                      <div className="flex items-center justify-between mb-6">
                        <div className="w-14 h-14 rounded-full bg-accent text-accent-foreground flex items-center justify-center text-2xl font-bold">
                          {step.step}
                        </div>
                        <div className="text-secondary">
                          <Icon size={40} />
                        </div>
                      </div>

                      {/* Content */}
                      <h3 className="text-2xl font-bold text-primary mb-4">
                        {step.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>

                  {/* Connector Arrow (Desktop) */}
                  {index < howItWorksData.length - 1 && (
                    <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                      <div className="text-secondary">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 12H19M19 12L12 5M19 12L12 19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
